module.exports = __webpack_public_path__ + "static/media/3_6John.32f4a8c6.png";